import { VENUES } from "@/config/contracts";

const ExternalIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    aria-hidden
    className="inline-block ml-1.5"
    style={{ verticalAlign: "baseline", color: "var(--ink-4)" }}
  >
    <path
      d="M3 1.5h5.5V7M8.5 1.5L4 6M4 1.5H1.5v7h7V6"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FooterNote = () => (
  <footer className="relative z-10 px-6 md:px-12 py-10">
    <div
      className="max-w-[1240px] mx-auto flex flex-col items-center gap-4"
      style={{ borderTop: "1px solid var(--line-2)", paddingTop: 24 }}
    >
      <nav className="flex items-center gap-6 lg:hidden">
        {(
          [
            { href: VENUES.morpho.href, label: "Morpho" },
            { href: VENUES.ajna.href, label: "Ajna" },
            {
              href: "https://aerodrome.finance/swap?from=0x833589fcd6edb6e08f4c7c32d4f71b54bda02913&to=0x043eb4b75d0805c43d7c834902e335621983cf03&chain0=8453&chain1=8453",
              label: "Aerodrome",
            },
          ] as const
        ).map(({ href, label }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="font-sans text-[12px] tracking-[0.12em] uppercase transition-opacity hover:opacity-70"
            style={{ color: "var(--ink-3)" }}
          >
            {label}
            <ExternalIcon />
          </a>
        ))}
      </nav>
      <span
        className="font-mono text-[10px] tracking-[0.18em] uppercase"
        style={{ color: "var(--ink-4)" }}
      >
        Sedge · 2026
      </span>
    </div>
  </footer>
);
